<template>
  <user-form
    :editable="true"
    :register="true"
    :input="null"
    @close="close_dialog"
    @submit="submit_registration"
  ></user-form>
</template>

<script>
export default {
  components: {
    UserForm: () => import(/* webpackChunkName: "startup" */ "../forms/UserForm"),
  },

  data() {
    return {}
  },

  methods: {
    close_dialog() {
        console.log('close')
    },

    submit_registration() {
      this.$emit('success')
    }
  },
};
</script>

<style>
</style>